export default __webpack_public_path__ + "static/camping_logo-80695a3aff234c335617d3a35b72301b.webp";